import Keycloak from 'keycloak-js'
import { fetchRequest } from './http.service'
import { GET_TERRITORIES, LOG_OUT, SET_USER_INFO } from '../redux/actionTypes'

const keycloakUrl = process.env.REACT_APP_KEYCLOAK
const keycloakRN = process.env.REACT_APP_KEYCLOAK_RN
const timeSkew = 0

export const keycloak = new Keycloak({
  clientId: 'itrader-front',
  realm: keycloakRN,
  bearerOnly: true,
  url: keycloakUrl,
  'auth-server-url': keycloakUrl,
  'ssl-required': 'none',
  resource: 'itrader-front',
  'public-client': false,

  'enable-cors': true,
  'cors-allowed-methods': 'GET, PUT, POST, HEAD, OPTIONS',
  'cors-allowed-headers': 'Origin, Accept, X-Requested-With, Content-Type, Last-Event-ID',

  checkLoginIframe: false,
  onLoad: 'login-required',
  // token: token || '',
  // refreshToken: refreshToken || '',
  timeSkew,
})

let userTmp = {}

export const checkKeycloakAuthentication = () => {
  if (!keycloak.isTokenExpired(30)) {
    return
  }

  keycloak
    .updateToken(30)
    .then(refreshed => {
      if (refreshed) {
        console.log('Token was successfully refreshed')
      }
    })
    .catch(err => {
      console.error(err)
    })
}

export const keycloakUpdateToken = () => {
  
    keycloak
    .updateToken(30)
    .then(refreshed => {
      if (refreshed) {
        console.log('Token was successfully refreshed', refreshed)
      }
      return refreshed;
    })
    .catch(err => {
      console.error(err)
    })
}

export const logout = store => {
  store.dispatch({
    type: LOG_OUT,
  })

  localStorage.removeItem('kc_token')
  localStorage.removeItem('kc_idToken')
  localStorage.removeItem('kc_refreshToken')

  keycloak.logout()
}

export const updateToken = (callback, callbackWhenNotRefreshed, minValidity) => {
  keycloak
    .updateToken(minValidity || 30)
    .then(refreshed => {
      if (refreshed) {
        callback && callback(localStorage.getItem('kc_token'))
      } else {
        callbackWhenNotRefreshed && callbackWhenNotRefreshed()
      }
    })
    .catch(err => {
      console.log('update token error', err)
      throw err
    })
}

export const loadAndStoreUser = (store, userInfo, userId) => {
  fetchRequest
    .get(`/users/${userId}`)
    .then(({ data }) => {
      store.dispatch({
        type: SET_USER_INFO,
        payload: {
          userId: userId,
          user: data,
        },
      })
      userTmp = data
      console.log('id klienta 2', userTmp)
    })
    .catch(err => {})
  /* const userLocale = userInfo.attributes.locale ? userInfo.attributes.locale[0] : 'cs'
  i18next.changeLanguage(userLocale).catch(() => {
    console.log('CANNOT CHANGE LANGUAGE')
  })
  console.log('USERLOCALE', userLocale) */
}

export const loadAndStoreTerritories = (store) => {
  fetchRequest
    .get('/businessterritory/')
    .then(({ data }) => {
      store.dispatch({
        type: GET_TERRITORIES,
        payload: {
          territories: data,
        },
      })
    })
    .catch(err => {})
}

export const eventLogger = store => (event, error) => {
  console.log('onKeycloakEvent', event, error)
  if (event === 'onAuthSuccess') {
    keycloak
      .loadUserProfile()
      .success(userInfo => {
        loadAndStoreUser(store, userInfo, keycloak.subject);
        loadAndStoreTerritories(store);
      })
      .error(err => {
        console.log('loadUserProfile: ', err)
        logout(store)
      })
  } else if (error) {
    console.log('onKeycloakEvent', event, error)
  }
}

export const getClientIdFromUser = () => {
  const id = keycloak?.idTokenParsed?.clientId
  // const id = userTmp?.clientId
  console.log('id klienta',id,userTmp);
  return id
}

export const isClientUser = () => {
  let clientId = getClientIdFromUser()
  return clientId !== undefined && clientId !== null && clientId !== ''
}

